import { FileText } from 'lucide-react';

/**
 * Section Synthèse (Phase 4) — Récapitulatif lecture seule
 * avant génération du rapport.
 */
export default function SectionSynthese({ data, dossier }) {
  const parcelle = data?.parcelles?.[0];
  const bien = parcelle?.biens?.[0];
  const valorisation = data?.valorisation;

  const items = [
    {
      label: 'Adresse du bien',
      value: parcelle?.adresse || 'Non renseignée',
    },
    {
      label: 'Type de bien',
      value: bien?.type_bien || 'Non renseigné',
    },
    {
      label: 'Surface habitable',
      value: bien?.surfaces?.surface_habitable_m2
        ? `${bien.surfaces.surface_habitable_m2} m²`
        : 'Non renseignée',
    },
    {
      label: 'Méthode de valorisation',
      value: valorisation?.methode_retenue || 'Non renseignée',
    },
    {
      label: 'Valeur retenue',
      value: data?.valeur_retenue_euros
        ? new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0,
          }).format(data.valeur_retenue_euros)
        : 'Non renseignée',
    },
    {
      label: 'Usage du rapport',
      value: dossier?.usage_rapport || 'Non renseigné',
    },
    {
      label: 'Date de visite',
      value: data?.date_visite || 'Non renseignée',
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 p-4 bg-carex-50 rounded-lg">
        <FileText className="w-5 h-5 text-carex-600" />
        <p className="text-sm text-carex-700">
          Vérifiez les données clés avant de générer le rapport depuis la page
          dossier.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">
        {items.map((item) => (
          <div
            key={item.label}
            className="flex items-center justify-between px-5 py-3.5"
          >
            <span className="text-sm font-medium text-slate-600">
              {item.label}
            </span>
            <span className="text-sm font-semibold text-slate-900">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
